$(function() {
	checkCustomInputs();
    $('[data-background], img[data-src]').imageLoader();
	
    $('.navbar-collapse a').on('click', function() {
        $('.navbar-toggle.active').trigger('click');
    });

    $('a.popup').on('click', function(e) {
        e.preventDefault();
        openPopup($(this).attr('href'), $(this).data('popup-width'), $(this).data('popup-height'));
    });

    $(document).on('click', 'a.confirm', function(e) {
        e.preventDefault();
        
        $('.confirm-popin .text').html($(this).data('confirm'));
        $('.confirm-popin .yes').attr('href', $(this).attr('href'));
        $('.confirm-popin').modal();
    });

    $(document).on('click', 'a.show-alert', function(e) {
        e.preventDefault();
        
        $('.alert-popin .text').html($(this).data('alert'));
        $('.alert-popin').modal();
    });
    
    $('input[type=number]').on('keyup', function() {
        var min   = parseInt($(this).attr('min'));
        var max   = parseInt($(this).attr('max'));
        var value = parseInt($(this).val());
        
        if (!isNaN(max) && value > max) {
            $(this).val(max);
        }
        
        if (!isNaN(min) && value < min) {
            $(this).val(min);
        }
    });
    
//    $('.modal').on('show.bs.modal', function (e) {
//        $('.modal-backdrop').on('click', function() {
//            console.log('click');
//            $('.modal').modal('hide');
//        });
//    });

    $(window).on('resize', function() {
   		checkSidebarHeight();
   	}).trigger('resize');

    $('.dashboard-scores').on('click',function(){
    	var targetUrl = $(this).data('scores-url');
    	window.location.href = targetUrl;
	});
	
	
	/* change body background-image: append parameter ?bg=3 */
	
	function parseLocation(val) {
		var result = '', tmp = [];
		location.search.substr(1).split('&').forEach(function (item) {
			tmp = item.split('=');
			if (tmp[0] === val) result = decodeURIComponent(tmp[1]);
		});
		return result;
	}
	
	var bg        = parseLocation('bg');
	var bgPath    = '';
	//var anticache = new Date().getTime();
	var anticache = '171212';
	
	switch(bg) {
		case '1':
			bgPath = '/site/assets/img/body-bg-2.jpg?' + anticache;
			document.styleSheets[0].addRule('body:before','background-image: url("'+bgPath+'");');
		break;
		
		case '2':
			bgPath = '/site/assets/img/body-bg-3.jpg?' + anticache;
			document.styleSheets[0].addRule('body:before','background-image: url("'+bgPath+'");');
		break;
		
		case '3':
			bgPath = '/site/assets/img/body-bg-4.jpg?' + anticache;
			document.styleSheets[0].addRule('body:before','background-image: url("'+bgPath+'");');
		break;
		
		case '4':
			bgPath = '/site/assets/img/body-bg-5.jpg?' + anticache;
			document.styleSheets[0].addRule('body:before','background-image: url("'+bgPath+'");');
		break;
		
		case '5':
			bgPath = '/site/assets/img/body-bg-6.jpg?' + anticache;
			document.styleSheets[0].addRule('body:before','background-image: url("'+bgPath+'");');
		break;
		
		case '6':
			bgPath = '/site/assets/img/body-bg-7.jpg?' + anticache;
			document.styleSheets[0].addRule('body:before','background-image: url("'+bgPath+'");');
		break;
		
		case '7':
			bgPath = '/site/assets/img/body-bg-8.jpg?' + anticache;
			document.styleSheets[0].addRule('body:before','background-image: url("'+bgPath+'");');
		break;
		
		case '8':
			bgPath = '/site/assets/img/body-bg-9.jpg?' + anticache;
			document.styleSheets[0].addRule('body:before','background-image: url("'+bgPath+'");');
		break;
	}
	
	/* end change body background-image */

});

var lastScrollTop = 0;
$(window).on('scroll', function() {
    var scrollTop = $(this).scrollTop();

    if (scrollTop > 0) {
        $('body').addClass('scrolled');
    } else {
        $('body').removeClass('scrolled');
    }
    

    if ($('.navbar-collapse').hasClass('in')) {
        return;
    }

    if ($('.navbar-top .icon-button.active').length == 0) {
        if (scrollTop <= lastScrollTop - 20 || scrollTop < 60) {
            $('.navbar-fixed-top, .header-loggedin-as').removeClass('up');
            lastScrollTop = scrollTop;

        } else if (scrollTop > lastScrollTop + 40) {
            $('.navbar-fixed-top, .header-loggedin-as').addClass('up');
            lastScrollTop = scrollTop;
        }
    }
});

$(window).on('mousewheel', function() {
    $(window).trigger('scroll');
});

$(window).on('beforeunload', function() {
    if (document.activeElement.hasAttribute('download')) {
        return;
    }

    if ($(document.activeElement).hasClass('no-loader')) {
        return;
    }

    $('html').addClass('loading');
});

setInterval(function() {
    $.get('/lib/keepalive.php');
}, 1000 * 60 * 10);
